
import categoryQuery from '@/apollo/queries/blog/category.gql';
import postsByCategoryQuery from '@/apollo/queries/blog/postsByCategory.gql';
import allCategoriesQuery from '@/apollo/queries/blog/allCategories.gql';
import previewModeMixin from '@/mixins/previewModeMixin';
import seoMixin from '@/mixins/seoMixin';
import {i18nPages} from "@/i18n.config.js";

export default {
  name: 'BlogTopicsSlug',
  colorMode: 'dark',
  mixins: [previewModeMixin, seoMixin],
  async asyncData({app, route}) {
    const categorySlug = route.params.slug;
    const locale = app.i18n?.locale || 'en';

    // Fetch current category details
    const {data: categoryData} = await app.apolloProvider.defaultClient.query({
      query: categoryQuery,
      variables: {
        slug: categorySlug,
        locale,
      },
    });

    const category = categoryData?.blogCategories?.data[0];

    if (!category) {
      // Handle category not found by returning nulls
      return {category: null, blogPosts: null, allCategories: []};
    }

    // Set route parameters for localization
    app.store.dispatch(
      "i18n/setRouteParams",
      Object.fromEntries(
        category.attributes.localizations.data.map((el) => [
          el.attributes.locale,
          {slug: el.attributes.slug},
        ])
      )
    );

    // Fetch posts for the current category
    const {data: postsData} = await app.apolloProvider.defaultClient.query({
      query: postsByCategoryQuery,
      variables: {
        slug: categorySlug,
        locale,
      },
    });

    // Fetch all categories for the categories list
    const {data: categoriesData} = await app.apolloProvider.defaultClient.query({
      query: allCategoriesQuery,
      variables: {locale},
    });

    const allCategories = categoriesData?.blogCategories?.data
      .map(cat => ({
        slug: cat.attributes.slug,
        title: cat.attributes.title,
      }))
      .sort((a, b) => a.title.localeCompare(b.title)) || [];

    return {category, blogPosts: postsData?.blogPosts, allCategories};
  },
  data() {
    return {
      blogPosts: null,
      category: null,
      allCategories: [],
      i18nPages,
    };
  },
  computed: {
    categoryTitle() {
      return this.category?.attributes?.title || '';
    },
    categoryDescription() {
      return this.category?.attributes?.description || '';
    },
    categorySEO() {
      return this.category?.attributes?.SEO || null;
    },
  },
  methods: {
    /**
     * Checks if the given slug is the current category.
     * @param {String|null} slug - The slug to check. If null, checks if "All" is active.
     * @returns {Boolean} - True if active, false otherwise.
     */
    isCurrentCategory(slug) {
      if (slug === null) {
        return this.$route.path === '/blog' || this.$route.path === '/bg/blog' || this.$route.path === '/es/blog';
      }

      return this.category?.attributes?.slug === slug;
    },
  },
};
